<template>
  <div class="rate-wrap">
    <div
      class="box-wrap"
      v-for="(item,index) in flyerData"
    >
      <Box
        :flyer="item"
        ref="box"
      ></Box>
    </div>
    <div
      class="submit"
      @click="getData()"
    >提交</div>
  </div>
</template>
<script>
import Box from "../rateBox/rateBox";
import axios from "../../http";
import { mapState } from "vuex";
export default {
  beforeRouteLeave(to, from, next) {
    if (!this.rated) {
      this.$dialog
        .confirm({
          title: "",
          message: "此次评价未完成，确定退出？"
        })
        .then(() => {
          // on confirm
          // this.$router.go(-1);
          // console.log("this.$route :>> ", this.$route);
          next();
        })
        .catch(() => {
          next(false);
          console.log("this.$route :>> ", this.$route);
          // on cancel
        });
    } else {
      next();
    }
  },
  name: "rate",
  components: { Box },
  props: {},
  data() {
    return {
      flyerData: [],
      rated: false
    };
  },
  computed: {
    ...mapState(["token"])
  },
  watch: {},
  mounted() {
    this.getParams();
  },
  created() {},
  update() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getParams() {
      let arr = JSON.parse(this.$route.query.groups);
      this.flyerData = [].concat(arr);
    },
    getData() {
      let ref = this.$refs.box;
      for (let i = 0; i < ref.length; i++) {
        if (ref[i].value == 0) {
          this.$toast("请选择星级评价");
          return false;
          //break 是跳出循环，不在继续
          //continue 是跳出当前循环，循环继续
          // return false 既跳出循环，也不在执行循环后面的代码
        }
      }
      //跳出循环 准备
      // return;
      this.postData();
      // console.log("ref :", ref[0].value);
    },
    postData() {
      let obj = {};
      this.$refs.box.forEach((el, index) => {
        obj["mid" + (index + 1)] = el.mid;
        obj["stars" + (index + 1)] = el.value;
        obj["content" + (index + 1)] = el.message;
        obj["image" + (index + 1)] = el.url;
      });
      obj.token = this.token;
      obj.order_sn = this.$route.query.order_sn;
      console.log("obj :", obj);
      axios
        .fetchPost("/api/order/comment_on", obj)
        .then(res => {
          let data = res.data;
          this.$toast(data.msg)
          if (data.code == 200) {
            this.rated = true;
            setTimeout(() => {  
              this.$router.push({
              path:"/orderDetail",
              query:{orderNumber:obj.order_sn}
            })
            },500) 
          }
        })
        .catch(error => {
          console.log("error :", error);
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
.rate-wrap
  padding-top 10px
  background #efefef
  overflow hidden
  .box-wrap
    width 95%
    padding-top 10px
    margin 0 auto
    background #ffffff
    font-family Microsoft YaHei
    text-align left
    margin-bottom 15px
    & > .title
      color #282828
      font-size 15px
      line-height 1.2
      margin 15px
      font-weight 400
    .name
      display flex
      align-items center
      margin-bottom 20px
      line-height 1.2
      .imgs
        width 40px
        height 40px
        background #55CC99
        border-radius 50%
        overflow hidden
        margin-right 15px
        margin-left 15px
      .names
        flex 1
      & > .title
        color #989898
        font-size 12px
        margin-right 10px
    .rate-box
      display flex
      margin-bottom 20px
      .rates
        flex 1
        margin-left 20px
      & > .titles
        font-size 15px
        margin-right 12px
    .upload-box
      border-top 1px solid #e5e5e5
      padding-top 15px
      padding-left 15px
      padding-bottom 15px
      & > .title
        color #C5C5C5
        font-size 13px
  .submit
    width 66%
    height 40px
    text-align center
    line-height 40px
    background rgba(85, 204, 153, 1)
    border-radius 40px
    font-size 17px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(255, 255, 255, 1)
    margin 20px auto
</style>